module.exports = __webpack_public_path__ + "static/media/import.bfc07f3b.svg";